/**
 * Wartezeit der Einstellungs-Synchronisation nach Fehlern in Folge.
 *
 * Bis 12.10.2026 hörte die Abfrage nach drei Fehlern in Folge **ganz** auf und lief erst nach einem
 * Neustart der App wieder. Drei Fehler sind auf einem Telefon Alltag (Funkloch, Aufzug, Gerät im
 * Hintergrund) — danach erfuhr das Gerät von keiner Einstellungsänderung mehr. Jetzt wird nur
 * seltener gefragt, nie gar nicht.
 */

/** Höchstens so viele Takte (je 30 s) werden übersprungen: alle 5 Minuten eine Abfrage. */
export const MAX_SKIPPED_TICKS = 9;

/**
 * Zahl der Abfragetakte, die nach `consecutiveErrors` Fehlern in Folge übersprungen werden:
 * 1 Fehler → 0 (30 s), 2 → 1 (1 min), 3 → 3 (2 min), 4 → 7 (4 min), ab 5 → 9 (5 min).
 */
export function skippedTicksAfterErrors(consecutiveErrors: number): number {
  if (consecutiveErrors <= 0) {
    return 0;
  }
  return Math.min(2 ** (consecutiveErrors - 1) - 1, MAX_SKIPPED_TICKS);
}
